module.exports = __webpack_public_path__ + "img/kl-marathon-2018.e03a91a8.png";